import { __decorate, __param } from './external/tslib/tslib.es6.js';
import { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
import { JSONValidationExtensionPoint } from './vscode/src/vs/workbench/api/common/jsonValidationExtensionPoint.js';
import { Extensions } from './vscode/src/vs/workbench/common/contributions.js';
import { ColorExtensionPoint } from './vscode/src/vs/workbench/services/themes/common/colorExtensionPoint.js';
import { IconExtensionPoint } from './vscode/src/vs/workbench/services/themes/common/iconExtensionPoint.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/workbenchReferenceSearch.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/menuPreventer.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/diffEditorHelper.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/largeFileOptimizations.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/inspectEditorTokens/inspectEditorTokens.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/saveParticipants.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleMinimap.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleMultiCursorModifier.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleRenderControlCharacter.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleWordWrap.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/toggleRenderWhitespace.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/editorLineNumberMenu.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatActionsMultiple.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatActionsNone.js';
import './vscode/src/vs/workbench/contrib/format/browser/formatModified.js';
import './vscode/src/vs/workbench/contrib/folding/browser/folding.contribution.js';
import './vscode/src/vs/workbench/contrib/inlayHints/browser/inlayHintsAccessibilty.js';
import './vscode/src/vs/workbench/contrib/codeActions/browser/codeActions.contribution.js';
import './vscode/src/vs/workbench/contrib/list/browser/list.contribution.js';
import './vscode/src/vs/workbench/contrib/codeEditor/browser/editorFeatures.js';
import './vscode/src/vs/workbench/contrib/contextmenu/browser/contextmenu.contribution.js';
let ExtensionPoints = class ExtensionPoints {
    constructor(instantiationService) {
        this.instantiationService = instantiationService;
        this.instantiationService.createInstance(JSONValidationExtensionPoint);
        this.instantiationService.createInstance(ColorExtensionPoint);
        this.instantiationService.createInstance(IconExtensionPoint);
    }
};
ExtensionPoints = __decorate([
    ( __param(0, IInstantiationService))
], ExtensionPoints);
( Registry.as(Extensions.Workbench)).registerWorkbenchContribution(ExtensionPoints, 1 );
